var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#34AADF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.67687 11.5749C6.67687 11.5749 11.5596 9.5184 13.253 8.79425C13.9022 8.50461 16.1036 7.57769 16.1036 7.57769C16.1036 7.57769 17.1197 7.1722 17.035 8.15701C17.0068 8.56254 16.781 9.98182 16.5552 11.517C16.2165 13.6894 15.8496 16.0646 15.8496 16.0646C15.8496 16.0646 15.7932 16.7308 15.3134 16.8466C14.8336 16.9625 14.0433 16.4411 13.9022 16.3252C13.7893 16.2384 11.7854 14.9349 11.0516 14.2977C10.854 14.1239 10.6282 13.7763 11.0798 13.3708C12.0958 12.4149 13.3095 11.2274 14.0433 10.4743C14.382 10.1267 14.7206 9.31563 13.3095 10.3004C11.3056 11.7198 9.32991 13.0522 9.32991 13.0522C9.32991 13.0522 8.87832 13.3418 8.03162 13.0811C7.18487 12.8205 6.19704 12.4729 6.19704 12.4729C6.19704 12.4729 5.51971 12.0384 6.67687 11.5749Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.df053255d7a7f367f9ca155d808b1ab3.svg";
export { ForwardRef as ReactComponent };